import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuItemExtrasComponent } from './menu-item-extras.component';

const routes: Routes = [
  { 
   path: '',
    children: [
      {
        path: 'default',
        component: MenuItemExtrasComponent,
        data: {
          title: "Menu Item Extras",
          breadcrumb: "Menu Item Extras"
        }
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenuItemExtrasRoutingModule { }
